import { useCallback } from "react";
import { useMappingStatus } from "providers/navigation/MappingStatusProvider";
import { useARC } from "providers/ARC/ARCProvider";
import { ConnectionState } from "lib/consts/ARC/connection";

const MappingToggleButton = () => {
    const mappingStatus = useMappingStatus();
    const { controlSocket, connectionState } = useARC();
    
    // Safety check - provide default if context not available
    const mappingEnabled = mappingStatus?.mappingEnabled ?? false;

    const handleToggle = useCallback(() => {
        if (!controlSocket || connectionState !== ConnectionState.Connected) {
            console.warn("Cannot toggle mapping: not connected");
            return;
        }

        // Toggle mapping: if currently off, enable it; if on, disable it
        const newEnabled = !mappingEnabled;

        // Debug: Publish to ROS2 topic
        // Topic: /slamware_ros_sdk_server_node/set_map_update
        // Message type: slamware_ros_sdk/msg/SetMapUpdateRequest
        // Message: { enabled: true/false }
        const setMapUpdateMsg = {
            enabled: newEnabled
        };

        console.log("[MappingToggleButton] Publishing mapping update:", newEnabled ? "ON" : "OFF");
        controlSocket.send("/slamware_ros_sdk_server_node/set_map_update", setMapUpdateMsg);
    }, [controlSocket, connectionState, mappingEnabled]);

    const isConnected = connectionState === ConnectionState.Connected;
    const buttonText = `Mapping: ${mappingEnabled ? "ON" : "OFF"}`;
    const buttonColor = mappingEnabled ? "bg-green-600" : "bg-red-600";

    return (
        <button
            onClick={handleToggle}
            disabled={!isConnected}
            className={`
                inline-flex h-10 shrink-0 items-center justify-center rounded-r5 px-3 text-sm font-medium text-white
                ${buttonColor}
                ${!isConnected ? "opacity-50 cursor-not-allowed" : "hover:opacity-80 cursor-pointer"}
                transition-opacity
            `}
        >
            {buttonText}
        </button>
    );
};

export default MappingToggleButton;

